module.exports = __webpack_public_path__ + "static/media/cyr_headSupport2.91321a3b.jpg";